import styled from 'styled-components';

import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

/**
 * Двухколоночный шаблон для страницы
 */
export const DoubleColumnLayout = styled(WideContainer)`
    display: grid;
    flex-wrap: nowrap;
    grid-template-columns: 1fr 480px;
    column-gap: 32px;
    margin-bottom: 30px;
    max-width: 100%;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        grid-template-columns: 1fr 384px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        grid-template-columns: 100%;
    }
`;
